<template>
    <main-layout>

        <!-- Header dégradé -->
        <div class="bg-gradient-to-b from-secondary to-primary">
            <app-header icon="docs" class="text-white pt-4 px-4">
                <h1 class="text-2xl flex items-center gap-3">Ajout installation </h1>
            </app-header>

            <!-- Barre d’actions (retour) -->
            <action-bar :back="{ name: 'liste-installations', params: { id: this.$route.params.id } }"
                class="px-4 pb-6"></action-bar>
        </div>
        <!-- Contenu principal -->
        <div
            class="bg-gradient-to-b from-[#F8FBFF] to-[#E2E9F5] rounded-t-3xl -mt-6 flex-1 overflow-y-auto shadow-xl pb-28">
            <div class="m-2 shadow-2xl rounded-xl overflow-hidden mb-8 bg-white">
                <form id="installation" class="p-4 md:p-6 space-y-6" @submit.prevent="sendForm">

                    <label class="label">Cette installation contient-elle du fluide frigorigène ?</label>

                    <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-3">
                        <!-- OUI -->
                        <div>
                            <input class="sr-only peer" type="radio" name="showF" id="showF_ok" :value="true"
                                v-model="showFluideSection" @change="choiceDone()" />
                            <label for="showF_ok"
                                class="!text-sm block rounded-lg px-4 py-3 bg-gray-200 text-gray-700 cursor-pointer transition peer-checked:bg-vert peer-checked:text-white peer-checked:shadow flex items-center justify-between">
                                <span>Oui</span>
                                <i class="icon-valid"></i>
                            </label>
                        </div>

                        <!-- NON -->
                        <div>
                            <input class="sr-only peer" type="radio" name="showF" id="showF_ko" :value="false"
                                v-model="showFluideSection" @change="choiceDone()" />
                            <label for="showF_ko"
                                class="!text-sm block rounded-lg px-4 py-3 bg-gray-200 text-gray-700 cursor-pointer transition peer-checked:bg-vert peer-checked:text-white peer-checked:shadow flex items-center justify-between">
                                <span>Non</span>
                                <i class="icon-valid"></i>
                            </label>
                        </div>
                    </div>

                    <div v-show="typeChoosed">

                        <!-- PHOTO OCR ONLY FOR USER ID 2600 -->
                        <div v-if="navigatorOnline && $user && $user.id === 2600">
                            <a @click="$refs.photoOCR.click()" class="flex items-center justify-center w-full px-4 py-3 text-sm font-medium text-white bg-blue-600 rounded-lg shadow-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors duration-200">
                                Remplissage automatique par photo
                                <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 ml-2" fill="none"
                                    viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
                                </svg>
                            </a>
                            <input type="file" ref="photoOCR" class="hidden" @change="handlePhotoOCR">
                        </div>

                        <!-- PHOTO OCR ONLY FOR USER ID 2600 -->
                        <div v-else-if="!navigatorOnline && $user && $user.id === 2600">
                            <button class="flex items-center justify-center w-full px-4 py-3 text-sm font-medium text-gray-400 bg-gray-300 rounded-lg cursor-not-allowed" disabled>
                                Remplissage automatique impossible hors ligne
                                <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 ml-2" fill="none"
                                    viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
                                </svg>
                            </button>
                        </div>

                        <label v-if="this.$route.query.itag">Otag install</label>
                        <input class="input mt-2" v-if="this.$route.query.itag" title="itag" type="text" name="i_tag"
                            v-model.trim="installation.i_tag" readonly>

                        <label class="label mt-2">Nom de l'installation <span class="text-alert">*</span></label>
                        <div class="flex">
                            <input class="input flex-1" title="installName" type="text" name="nom" id="nom"
                                maxlength="255" value="" v-model.trim="installation.nom">
                            <a v-if="optionBarcode === true" href="fi360://scan?success=fillCodeBarre&type=installation"
                                id="barcode-scan"
                                class="bg-secondary text-white ml-2 rounded flex items-center justify-center">
                                <img src="../../img/barcode-scan.png" class="h-9" alt="Scanner le code-barres">
                            </a>
                        </div>

                        <label class="label">Marque <span class="text-alert"
                                v-show="showFluideSection === false">*</span></label>
                        <input class="input" title="marque" type="text" name="nom" id="marque" maxlength="255" value=""
                            v-model.trim="installation.marque">

                        <label class="label">Modèle / N° de série / Repère <span class="text-alert"
                                v-show="showFluideSection === false">*</span></label>
                        <input class="input" title="model" type="text" name="nom" id="modele" maxlength="255" value=""
                            v-model.trim="installation.modele">

                        <a href="javascript: void 0" class="btn-secondary my-6 photo"
                            @click="$refs.photoInstall.click()">
                            PHOTO INSTALLATION / PLAQUE SIGNALETIQUE
                            <i class="icon-photo"></i>
                        </a>
                        <input class="input" type="file" ref="photoInstall" v-show="false" @change="handlePhotoInstall">
                        <div class="preview-img" v-if="installation.photo">
                            <i class="icon icon-delete" @click="installation.photo = null"></i>
                            <img :src="installation.photo" alt="photo installation" id="photo-install">
                        </div>

                    </div>

                    <div v-show="showFluideSection">

                        <label class="label">Type de fluide <span class="text-alert">*</span></label>
                        <select class="input" ref="fluide" title="fluid" v-model="installation.fluide"
                            @change="updateComputed">
                            <option disabled selected>Sélectionnez un fluide</option>
                            <option v-for="fluide in fluides" :key="fluide && fluide.id" :value="fluide"
                                v-if="fluide && fluide.nom !== 'R-999'">
                                {{ fluide.nom }}
                                {{ (fluide.nom_commercial) ? ' - ' + fluide.nom_commercial : '' }}
                            </option>
                        </select>

                        <label class="label">Charge totale (Kg) <span class="text-alert">*</span></label>
                        <input class="input" title="chargeTotal" type="number" ref="charge" step="0.001" min="0.010"
                            v-model.number="installation.charge" inputmode="decimal" @change="updateComputed">

                        <label class="label">Détecteur de fuite fixe <span class="text-alert">*</span></label>

                        <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-3">
                            <!-- Oui -->
                            <div>
                                <input class="sr-only peer" name="detecteur_fuite_fixe" ref="detec" id="fuite_ok"
                                    type="radio" :value="true" v-model="installation.detecteur"
                                    @change="updateComputed" />
                                <label for="fuite_ok" class="!text-sm block rounded-lg px-4 py-3 bg-gray-200 text-gray-700 cursor-pointer transition peer-checked:bg-vert peer-checked:text-white peer-checked:shadow flex items-center justify-between">
                                    <span>Oui</span>
                                    <i class="icon-valid"></i>
                                </label>
                            </div>

                            <!-- Non -->
                            <div>
                                <input class="sr-only peer" name="detecteur_fuite_fixe" ref="detec2" id="fuite_ko"
                                    type="radio" :value="false" v-model="installation.detecteur"
                                    @change="updateComputed" />
                                <label for="fuite_ko" class="!text-sm block rounded-lg px-4 py-3 bg-gray-200 text-gray-700 cursor-pointer transition peer-checked:bg-rouge peer-checked:text-white peer-checked:shadow flex items-center justify-between">
                                    <span>Non</span>
                                    <i class="icon-valid"></i>
                                </label>
                            </div>
                        </div>


                        <div v-if="canForceFrequence === true" class="mt-6">
                            <label class="label">Fréquence de contrôle forcée</label>

                            <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-3">
                                <!-- Oui -->
                                <div>
                                    <input class="sr-only peer" name="force_frequence" id="force_frequence" type="radio"
                                        :value="true" v-model="installation.force_frequence" @change="updateComputed" />
                                    <label for="force_frequence" class="!text-sm block rounded-lg px-4 py-3 bg-gray-200 text-gray-700 cursor-pointer transition peer-checked:bg-vert peer-checked:text-white peer-checked:shadow flex items-center justify-between">
                                        <span>Oui</span>
                                        <i class="icon-valid"></i>
                                    </label>
                                </div>

                                <!-- Non -->
                                <div>
                                    <input class="sr-only peer" name="force_frequence" id="force_frequence_no"
                                        type="radio" :value="false" v-model="installation.force_frequence"
                                        @change="updateComputed" />
                                    <label for="force_frequence_no" class="!text-sm block rounded-lg px-4 py-3 bg-gray-200 text-gray-700 cursor-pointer transition peer-checked:bg-rouge peer-checked:text-white peer-checked:shadow flex items-center justify-between">
                                        <span>Non</span>
                                        <i class="icon-valid"></i>
                                    </label>
                                </div>
                            </div>
                        </div>


                        <div v-if="installation.force_frequence === true">
                            <label class="label">Fréquence de contrôle</label>
                            <select name="frequence_controle" id="frequence_controle" class="input mt-2"
                                v-model="installation.frequence_controle">
                                <option value="3">3 mois</option>
                                <option value="6">6 mois</option>
                                <option value="12">12 mois</option>
                                <option value="24">24 mois</option>
                            </select>
                        </div>

                        <input class="input" type="hidden" v-model.number="installation.tonnage">

                        <input class="input" type="hidden" v-model.number="installation.frequence_controle">

                        <div style="display: inline-block; width: 100%">
                            <p v-if="installation.fluide && installation.fluide.type && installation.fluide.type !== 'HFO'">
                                Tonnage équivalent CO<span class="smallexp">2</span> :
                                <span id="tonnage" v-text="installation.tonnage"
                                    class="text-secondary font-bold"></span>
                            </p>

                            <p v-if="installation.fluide && installation.fluide.gwp">
                                GWP :
                                <span id="gwp" v-text="installation.fluide.gwp" class="text-secondary font-bold"></span>
                            </p>

                            <p
                                v-if="installation.fluide && installation.fluide.type !== 'CFC' && installation.detecteur !== null">
                                Fréquence de contrôle de l'installation :
                                <span id="frequence" class="text-secondary font-bold">{{ installation.frequence_controle === 0 || installation.frequence_controle == null ? 'Aucune' : installation.frequence_controle + ' Mois' }}</span>
                            </p>
                        </div>

                    </div>



                    <div class="clear"></div>

                    <div v-show="typeChoosed">
                        <input class="btn-primary" type="submit" id="submit-install" name="new" value="AJOUTER">
                    </div>

                </form>
            </div>
        </div>
    </main-layout>
</template>

<script>
import Installation from '../../js/models/Installation';

import Operateur from "@/js/models/Operateur";
import loadImage from 'blueimp-load-image';
import localforage from "localforage";

export default {

    data() {
        return {
            installation: {
                nom: null,
                marque: null,
                modele: null,
                photo: null,
                fluide: {},
                charge: null,
                detecteur: null,
                tonnage: null,
                frequence_controle: null,
                i_tag: null,
            },
            fluides: null,
            showFluideSection: null,
            typeChoosed: false,
            canForceFrequence: false,
            optionBarcode: false,
            navigatorOnline: navigator.onLine,
        }
    },

    methods: {

        choiceDone() {
            this.typeChoosed = true;
            if (false === this.showFluideSection) {
                this.installation.fluide = {};
                this.installation.charge = null;
                this.installation.detecteur = null;
                this.installation.tonnage = null;
                this.installation.frequence_controle = null;
            }
        },

        sendForm() {

            if (this.showFluideSection !== null) {

                let installation = this.installation;
                let errors = [];

                // CONDITION COMMUNE
                if (!installation.nom) {
                    errors.push("le nom de l'installation")
                }

                if (this.showFluideSection === false) {

                    if (!installation.marque) {
                        errors.push("la marque")
                    }
                    if (!installation.modele) {
                        errors.push("le modèle")
                    }

                } else if (this.showFluideSection === true) {

                    if (_.isEmpty(installation.fluide)) {
                        errors.push("le fluide")
                    }
                    if (!installation.charge) {
                        errors.push("la charge")
                    }
                    if (installation.detecteur === null) {
                        errors.push("le détecteur")
                    }

                }

                if (errors.length !== 0) {

                    let txt = errors.join(', ');
                    swal('Information(s) manquante(s) :', 'Veuillez renseigner ' + txt + '.', 'error')

                } else {

                    //console.log(installation);
                    Installation
                        .addInstallationOffline({ data: this.$data, idDet: this.$route.params.id })
                        .then(() => {
                            /*
                                if (navigator.onLine) {
                                    Synchro.syncIntallations(true);
                                }
                            */
                            swal({
                                title: 'Installation ajoutée !',
                                html: 'L\'installation a bien été ajoutée.',
                                type: 'success',
                                confirmButtonText: 'OK',
                                allowOutsideClick: false
                            }).then(() => {
                                this.$router.push({ name: 'liste-installations', params: { id: this.$route.params.id } })
                            })
                        })
                        .catch()

                }

            } else {

                swal('Formulaire incomplet', "Veuillez préciser si l'installation contient du fluide frigorigène", 'error')

            }

        },

        fetchFluides() {

            let vueInstance = this;

            localforage.getItem('listFluides')
                .then(fluides => {
                    fluides = JSON.parse(fluides);
                    vueInstance.fluides = fluides.noFiltre.filter(f => !f.regenerated);
                })
                .catch()
        },

        handlePhotoInstall(e) {
            let vueInstance = this;

            loadImage(
                e.target.files[0],
                function (img) {
                    vueInstance.installation.photo = img.toDataURL();
                },
                {
                    maxWidth: 700,
                    maxHeight: 700,
                    orientation: true,
                    canvas: true
                }
            )

        },

        handlePhotoOCR(e) {
            let vueInstance = this;

            let file = e.target.files[0];

            let formData = new FormData();
            formData.append('photo', file);

            //send PROD FIGZ
            fetch('https://figz.app.n8n.cloud/webhook/6e748d30-46c9-40ab-8acf-d85d4da97849', {
                method: 'POST',
                body: formData
            })
                .then(response => response.json())
                .then(data => {
                    vueInstance.$refs.photoOCR.value = null;
                    console.log(data);
                    if (data.nom_installation) {
                        vueInstance.installation.nom = data.nom_installation;
                    }
                    if (data.marque) {
                        vueInstance.installation.marque = data.marque;
                    }
                    let modele_full = '';
                    if (data.modele) {
                        modele_full += data.modele;
                    }
                    if (data.numero_serie) {
                        modele_full += " / " + data.numero_serie;
                    }
                    if (data.repere) {
                        modele_full += " / " + data.repere;
                    }

                    if (modele_full !== '') {
                        vueInstance.installation.modele = modele_full;
                    }

                    if (data.fluide) {
                        const fluideRecherche = data.fluide.toLowerCase().replace(/-/g, '');
                        let found_fluide = vueInstance.fluides.find(f => {
                            const nom = f.nom ? f.nom.toLowerCase().replace(/-/g, '') : '';
                            const nomCommercial = f.nom_commercial ? f.nom_commercial.toLowerCase().replace(/-/g, '') : '';
                            return nom === fluideRecherche || nomCommercial === fluideRecherche;
                        });

                        if (found_fluide) {
                            vueInstance.installation.fluide = found_fluide;
                            vueInstance.updateComputed();
                        }
                    }

                    if (data.charge_kg) {
                        vueInstance.installation.charge = parseFloat(data.charge_kg);
                    }
                })
                .catch(e => {
                    //vider l'input file
                    vueInstance.$refs.photoOCR.value = null;
                    console.log(e)
                });

        },


        updateComputed() {

            if (_.has(this.installation.fluide, 'gwp') && this.installation.charge !== null) {
                this.updateTonnage();

                if (this.installation.detecteur !== null && this.installation.force_frequence !== true) {
                    this.updateFrequence()
                }
            }
        },

        updateTonnage() {
            this.installation.tonnage = round(this.installation.fluide.gwp * this.installation.charge / 1000, 4);

        },

        updateFrequence() {

            let tonnage = this.installation.tonnage;
            let detecteur = this.installation.detecteur;
            let charge = this.installation.charge;
            let freq = 0;

            if (this.installation.fluide.type === 'HCFC') {
                if (charge > 3 && charge < 30) {
                    freq = 12;
                } else if (charge >= 30 && charge < 300) {
                    freq = 6;
                } else if (charge >= 300) {
                    freq = 3;
                }
            } else if (this.installation.fluide.type !== 'HCFC') {
                if (tonnage > 5 && tonnage < 50) {
                    freq = 12;
                } else if (tonnage >= 50 && tonnage < 500) {
                    freq = 6;
                } else if (tonnage >= 500) {
                    freq = 3;
                }
            }

            if (detecteur === true) {
                freq = freq * 2;
            }

            this.installation.frequence_controle = freq

        },

        setupMobileInputScroll() {
            // Attendre que le DOM soit complètement rendu
            /*this.$nextTick(() => {
                const inputs = this.$el.querySelectorAll('input, select, textarea');
                inputs.forEach(input => {
                    input.addEventListener('focus', (e) => {
                        // Délai pour laisser le clavier apparaître
                        setTimeout(() => {
                            e.target.scrollIntoView({
                                behavior: 'smooth',
                                block: 'center',
                                inline: 'nearest'
                            });
                        }, 300);
                    });
                });
            });*/
        }
    },

    mounted: function () {
        this.fetchFluides();
        if (this.$route.query.itag != null) {
            this.installation.i_tag = this.$route.query.itag;
        }

        Operateur.getOperateurOption(options => {
            this.canForceFrequence = options.includes('force_install_frequence');
            this.optionBarcode = options.includes('scan_barcode_install');
        })

        // Gestion du scroll automatique pour mobile quand le clavier apparaît
        this.setupMobileInputScroll();

    },
}

</script>

<style>
.preview-img {
    position: relative;
}

.preview-img i {
    position: absolute;
    right: 10px;
    padding-top: 5px;
    top: 10px;
    color: #fff;
    background-color: #c31616;
    font-size: 2.7rem;
    border-radius: 5px;
    height: 40px;
    width: 50px;
    text-align: center;
}

.btn-full.photo {
    padding-left: 20px;
    font-weight: 700;
    margin-bottom: 10px;
}

.btn-full.photo i {
    position: absolute;
    right: 20px;
    top: 10px;
    font-size: 2.5rem;
    color: #fff;
    margin: auto;
}

img#photo-install {
    margin-bottom: 10px;
    max-width: 320px;
}

div.radio {
    display: block;
    float: left;
    margin-right: 20px;
    margin-bottom: 15px;
}

div.radio input {
    display: none;
}

div.radio input:checked+label {
    background-color: #86bc24;
    color: #fff;
}

div.radio input:checked+label i {
    color: #fff;
}

div.radio label {
    position: relative;
    height: 50px;
    width: 100px;
    border-radius: 5px;
    background-color: #e2e2e2;
    color: #999;
    padding-left: 20px;
    line-height: 3.5;
    transition: all 250ms ease;
}

div.radio label i {
    position: absolute;
    right: 10px;
    top: 15px;
    font-size: 2rem;
    color: #999;
}
</style>



// WEBPACK FOOTER //
// NewInstallation.vue?7c32617d